import { render, staticRenderFns } from "./ErrorAlerta.vue?vue&type=template&id=d2009a9a&scoped=true"
import script from "./ErrorAlerta.vue?vue&type=script&lang=js"
export * from "./ErrorAlerta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2009a9a",
  null
  
)

export default component.exports